.positionRelative {
  position: relative;
}

.backgroundTimePicker {
  visibility: hidden;
  z-index: -1;
  width: calc(100% - 51px);
}

.timePickerContainer {
  position: absolute;
  width: calc(100% - 5px);
  left: 0px;
  top: 0px;
  display: flex;
}

.timePicker {
  flex-grow: 1;
}

.inputMask {
  height: 100%;
  width: 100%;
  padding-left: 10px;
  box-sizing: border-box;

  font: var(--cont-typography-common-body-200-base);

  border-radius: 0;
  border: 1.5px solid var(--cont-color-field-border-on-layer-1-subtle);
  outline: none;

  background-color: var(--cont-color-field-bg-on-layer-1-subtle);

  &:hover {
    background-color: var(--cont-color-field-bg-on-layer-1-moderate);
  }

  &:focus-within {
    background-color: var(--cont-color-field-bg-on-layer-1-subtle);
    border-color: var(--cont-color-field-border-on-layer-1-moderate);
  }

  &:disabled {
    cursor: not-allowed;
    background-color: var(--cont-color-field-bg-on-layer-1-moderate);
  }

  &.invalid {
    border-color: var(--core-color-role-negative);
  }

  &::placeholder {
    color: var(--color-field-placeholder);
    font: var(--cont-typography-field-md);
  }
}

.exclamationMarkIcon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--core-color-role-negative);
}
